<template>
  <div class="payment-status">
    <!-- Spinner UI shown while loading -->
    <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
      <p>Verifying your payment, please wait...</p>
    </div>
  </div>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
import { nextTick } from "vue";
export default {
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    const orderId = this.$route.query.order_id || this.$route.params.order_id;
    console.log("orrerId", orderId);

    if (orderId) {
      this.verifyPaymentStatus(orderId);
    } else {
      this.$refs.toast.show("Missing order ID", "error");
    }
  },
  methods: {
    async verifyPaymentStatus(orderId) {
      this.loading = true;
      try {
        const status =
          await NetworkService.PaymentService.verifyAndHandlePaymentStatus(
            orderId
          );
        console.log("status line 36", status);

        if (status === "SUCCESS") {
          this.$refs.toast.show("Payment successful", "success");
          setTimeout(() => {
            this.loading = false;
            this.$router.push({ name: "ThankYou" });
          }, 2000);
        } else if (status === "FAILED") {
          setTimeout(async () => {
            this.loading = false;
            // this.$router.back();
            await nextTick();
            this.$router.push({ name: "OurServices" });
            this.$refs.toast.show("Payment failed", "error");
          }, 3000);
        } else if (status === "PENDING") {
          setTimeout(async () => {
            this.loading = false;
            // this.$router.back();
            await nextTick();
            this.$router.push({ name: "OurServices" });
          }, 10000);
          this.$refs.toast.show("Payment is still pending", "info");
        } else {
          this.loading = false;
          setTimeout(async () => {
            this.loading = false;
            await nextTick();
            this.$router.push({ name: "OurServices" });
          }, 2000);

          this.$refs.toast.show("Payment Failed", "error");
        }
      } catch (error) {
        const errorInfo = NetworkService.PaymentService.handleError(error);
        this.$refs.toast.show(errorInfo.message, "error");
        setTimeout(async () => {
            this.loading = false;
            await nextTick();
            this.$router.push({ name: "OurServices" });
          }, 2500);
      }
    },
  },
};
</script>

<style scoped>
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
